import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import { api } from '../api';

function SuiteNode({ suite, index, total }) {
  const { projectId, suiteId } = useParams();
  const navigate = useNavigate();
  const { refresh } = useContext(AppContext);
  const [expanded, setExpanded] = useState(true);
  const [adding, setAdding] = useState(false);
  const [childName, setChildName] = useState('');
  const hasChildren = suite.children && suite.children.length > 0;
  const isActive = Number(suiteId) === suite.id;

  const handleSelect = () => navigate(`/projects/${projectId}/suites/${suite.id}`);

  const handleAddChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!childName.trim()) return;
    await api.createSuite({ name: childName.trim(), project_id: suite.project_id, parent_id: suite.id });
    setChildName('');
    setAdding(false);
    refresh();
  };

  const handleDelete = async (e) => {
    e.stopPropagation();
    if (!window.confirm(`Delete suite "${suite.name}"?`)) return;
    try {
      await api.deleteSuite(suite.id);
      if (isActive) navigate(`/projects/${projectId}`);
      refresh();
    } catch (err) {
      alert(err.message);
    }
  };

  const handleMove = async (e, direction) => {
    e.stopPropagation();
    await api.reorderSuite(suite.id, direction);
    refresh();
  };

  return (
    <div className="suite-node">
      <div className={`suite-node-row ${isActive ? 'active' : ''}`} onClick={handleSelect}>
        <span className="suite-toggle" onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}>
          {hasChildren ? (expanded ? '▾' : '▸') : '·'}
        </span>
        <Link
          to={`/projects/${projectId}/suites/${suite.id}`}
          className="suite-name"
          onClick={(e) => e.stopPropagation()}
        >
          {suite.name}
        </Link>
        <div className="suite-actions">
          <button onClick={(e) => handleMove(e, 'up')} disabled={index === 0} className="suite-move-btn" title="Move up">↑</button>
          <button onClick={(e) => handleMove(e, 'down')} disabled={index === total - 1} className="suite-move-btn" title="Move down">↓</button>
          <button onClick={(e) => { e.stopPropagation(); setAdding(!adding); }} title="Add child">+</button>
          <button onClick={handleDelete} title="Delete">×</button>
        </div>
      </div>
      {adding && (
        <form className="add-suite-form" onSubmit={handleAddChild} style={{ marginLeft: 20 }}>
          <input value={childName} onChange={(e) => setChildName(e.target.value)} placeholder="Child suite" autoFocus />
          <button type="submit">Add</button>
        </form>
      )}
      {expanded && hasChildren && (
        <div className="suite-children">
          {suite.children.map((child, i) => (
            <SuiteNode key={child.id} suite={child} index={i} total={suite.children.length} />
          ))}
        </div>
      )}
    </div>
  );
}

export default function SuiteTree() {
  const { projectId } = useParams();
  const { refreshKey, refresh } = useContext(AppContext);
  const [suites, setSuites] = useState([]);
  const [newName, setNewName] = useState('');

  useEffect(() => {
    if (projectId) api.getSuites(Number(projectId)).then(setSuites);
  }, [projectId, refreshKey]);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    await api.createSuite({ name: newName.trim(), project_id: Number(projectId), parent_id: null });
    setNewName('');
    refresh();
  };

  return (
    <div>
      <div className="suite-header"><h3>Suites</h3></div>
      {suites.map((s, i) => (
        <SuiteNode key={s.id} suite={s} index={i} total={suites.length} />
      ))}
      <form className="add-suite-form" onSubmit={handleAdd}>
        <input value={newName} onChange={(e) => setNewName(e.target.value)} placeholder="New suite" />
        <button type="submit">Add</button>
      </form>
    </div>
  );
}
